<template>
<div>
  <div class="container-fluid mt--5 filter-show">
        <div class="card w-100 p-2 mb-2  d-inline-block">
      <div class="d-flex justify-content-between">
         <h5 class="ml-3">Filters</h5>
         <span class="btn btn-link" @click="showFilters = !showFilters">
         <i class="fa" v-bind:class="[showFilters ? 'fa-angle-up' : 'fa-angle-down']" ></i> {{showFilters ? 'Hide' : 'Show'}} Filters
         </span>
      </div>
      <div class="row" v-if="showFilters">
         <div class="col-lg-12">
            <form class="row">
               <div class="col-md-6 col-lg-4">
                  <label for="filter" class="col-form-label">Accounts</label>
                  <multiselect 
                    v-model="filterAccounts" 
                    placeholder="Select" 
                    label="account" 
                    track-by="accountMappingId" 
                    :options="accountList" 
                    @select="searchHoldingDelayed()"
                    @remove="searchHoldingDelayed()"
                    :multiple="true" 
                    :limit="3"  ></multiselect>
                </div>
               <div class="col-md-6 col-lg-4 mt-2">
                  <button @click.prevent="clearFilter()" type="button" class="btn btn-secondary rounded">Clear</button>
                  <button @click.prevent="searchHolding()" type="button" class="btn btn-primary rounded">Filter</button>
               </div>
            </form>
         </div>
      </div>
        </div>
  </div>
  <div class="container-fluid tbl-flt-sch">
    <div class="abs-btn-grp">
      <div v-if="selectedCount > 0" class="selection-chip align-self-center mr-2">
        <span class="selection-chip__count">Selected: {{ selectedCount }}</span>
        <button @click="clearSelection()" type="button" class="selection-chip__clear" title="Clear selection">
          <i class="fas fa-times"></i>
        </button>
      </div>
      <button v-if="isOperator" :disabled="!canBulkAssign" @click="assignSelectedToMe()" type="button" class="btn btn-primary"><i class="fas fa-user-check"></i> ASSIGN ALL TO ME</button>
      <button v-if="isOperator" :disabled="!canBulkSend" @click="sendSelectedToEcn()" type="button" class="btn btn-success"><i class="fas fa-paper-plane"></i> SEND ALL TO ECN</button>
      <!-- Table Search -->
      <form  @submit.prevent="" class="d-inline-flex mt-0 ml-2">
        <i @click="searchHolding()" data-v-d13f7de6="" aria-hidden="true" class="fas fa-search active cursor-pointer"></i>
        <input v-on:keyup.enter="searchHolding" v-model.trim="searchValue"  @keypress="isAlphanumeric($event)"  data-v-d13f7de6="" type="text" placeholder="Search Here" aria-label="Search" class="form-control form-control-sm ml-3 mr-3">
        <i v-if="searchValue" @click="clearSearch()" class="fas fa-times-circle cursor-pointer"></i>
      
      </form>
    </div>
      <div class="row xsOnly">
        <div class="col-xl-12">
          <div class="card scrollbar vh-75" id="scroll">
            <div class="table-responsive">
                  <table class="table align-items-center table-flush table-hover bidtbl bid-acc">
                      <thead class="thead-light psticky">
                      <tr >
                        <th
                          scope="col"
                          class="text-center"
                          v-if="isOperator"
                          ><input v-model="isSelectAll" @change="selectAll()" type="checkbox" class="form-check-input" /></th>
                        <th 
                          scope="col" 
                          class="sort text-left"
                          >CUSTOMER | ACCOUNT</th>
                        <th 
                        scope="col" 
                        class="sort text-center"
                        >CUSIP/DESC</th>
                        <th 
                        scope="col" 
                        class="sort text-center"
                        >COUPON</th>
                        <th 
                        scope="col" 
                        class="sort text-center"
                        >MATURITY DATE/<br>CALL DATE</th>
                        <th 
                        scope="col" 
                        class="sort text-center"
                        >MOODY'S/ <br>S&P RATING</th>
                        <th 
                        scope="col" 
                        class="sort text-center"
                        >INSURER</th>
                        <th 
                        scope="col" 
                        class="sort text-center"
                        >COST</th>
                        <th 
                        scope="col" 
                        class="sort text-center"
                        >TRADER/ADMIN</th>
                        <th 
                        scope="col" 
                        class="sort text-center"
                        >OPERATOR</th>
                        <th 
                        scope="col" 
                        class="sort text-center"
                        >SELL QTY</th>
                        <th 
                        scope="col" 
                        class="sort text-center"
                        >HOLDINGS</th> 
                        <th 
                        scope="col" 
                        class="sort text-center"
                        v-if="isOperator"
                        >ACTION</th>
                      </tr>
                      </thead>
                      <tbody class="list">
                      <tr v-if="totalRows == 0 && !loading">
                          <td><p class="nodata">No data available</p>
                          </td>
                      </tr>
                      <tr v-for="holding in holdingsList" :key="holding.id"  >
                        <td class="text-center" v-if="isOperator">
                          <input v-model="holding.isSelect" @change="selectHolding(holding)" type="checkbox" class="form-check-input" />
                        </td>
                        <td class="text-left">
                          <div v-for="customer in holding.bidWantedInventoryListDtoAccount"  :key="customer.id">
                            <span class="text-primary">{{customer.customerFirstName ? customer.customerFirstName[0] : ""}} {{customer.customerLastName}}</span>
                            | <span class="text-success">{{customer.accountVal}}</span> 
                          </div>
                        </td>
                        <td class="text-center">
                            <span class="cusips">{{holding.cusipVal}}</span><br>
                            <span data-toggle="tooltip" data-placement="left"  v-bind:title='holding.cusipDescription'>{{holding.cusipDescription | truncate(20, '...')}}</span>
                        </td>
                        <td class="text-center"><span>{{holding.coupon |  percent(3) }}</span></td>
                        <td class="text-center">
                          <span class="maturity">{{holding.maturityDate ? moment(holding.maturityDate).format("MM/DD/YYYY") : "N/A"}}</span><br>
                        {{holding.callDate ? moment(holding.callDate).format("MM/DD/YYYY") : "N/A"}}
                        </td>
                        <td class="text-center"><span class="text-primary">{{holding.ratingMoody ? holding.ratingMoody : "N/A"}}</span>
                            <span class="insurer text-success">{{holding.ratingSP ? holding.ratingSP : "N/A"}}</span>
                        </td>
                        <td class="text-center"><span class="insurer">{{holding.bondInsurer ? holding.bondInsurer : "N/A"}}</span></td>
                        <td class="text-center">
                            <span class="text-success">{{holding.cost | currency}}</span><br>
                        </td>
                        <td class="text-center">
                            <span>{{holding.traderFirstName}} {{holding.traderLastName}}</span><br>
                        </td>
                        <td class="text-center">
                            <span v-if="holding.operatorCognitoSub && holding.operatorCognitoSub != cognitoSub">{{holding.operatorFirstName}} {{holding.operatorLastName}}</span>
                            
                            <span class="text-success" v-if="holding.operatorCognitoSub === cognitoSub">Me</span>
                        </td>  
                        <td class="text-center">
                            <span>{{holding.sellQuantity}}</span>
                        </td> 
                        <td  class="text-center">
                          <button @click="toggleViewHoldingModalOpen(holding.bidWantedInventoryListDto)" class="btn ibtn btn-outline-primary" title="Holding"><i class="far fa-user"></i></button>

                        </td>
                        <td class="text-center" v-if="isOperator">
                          <button :disabled="holding.operatorCognitoSub" @click="assignToMe(holding)" type="button" class="btn btn-primary" >ASSIGN TO ME</button>
                          <button :disabled="!(holding.operatorCognitoSub === cognitoSub)" @click="sendToEcn(holding)" type="button" class="btn btn-success" ><i class="fas fa-paper-plane"></i> SEND TO ECN</button>
                        </td>
                        </tr>
                      </tbody>
                      <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>

                  </table>
                  <!-- Pagination-->
                  <b-pagination
                      class="mt-4"
                      :total-rows="totalRows"
                      v-model="currentPage"
                      :per-page="perPage"
                      @input="getHoldingList(currentPage)"
                  ></b-pagination>
                  <div class="total-records">
                      <span>Total Records : {{totalRows}}</span>
                  </div>
            </div>
          </div>
        </div>
      </div>
    <CreateBidWanted  v-bind:holding="selectedHolding" v-if="createBidWantedModalOpen" @close="toggleCreateBidWantedModalOpen()" />
    <BulkSendToEcn  v-if="bulkSendToEcnModalOpen" v-bind:bulkPayload="bulkPayload" v-bind:bulkResult="bulkResult" @close="toggleBulkSendToEcnModalOpen()" />
    <ViewHoldings  v-bind:holding="holdingsInBidWanted" v-if="viewHoldingModalOpen" @close="toggleViewHoldingModalOpen()" />
    
  </div>
</div>    
</template>
<script>
import CreateBidWanted from '../../ba-common/BaCreateBidWantedModal';
import BulkSendToEcn from '../../ba-common/BaBulkSendToEcnModal';
import ViewHoldings from '../../ba-common/BaViewHoldingListModal';
import config from "@/config";
import authService from "@/authService";
export default {
  name: "baAllHoldingsTrader",
  components : {
    CreateBidWanted,
    BulkSendToEcn,
    ViewHoldings
  },
  data() {
    return {
        loading : false,
        currentPage: 1,
        perPage: 20,
        searchValue : "",
        sortColumn: "id",
        sortOrder:"DESC",
        totalRows : 0,
        createBidWantedModalOpen : false,
        bulkSendToEcnModalOpen : false,
        holdingsList : [],
        selectedHolding : null,
        cognitoSub: authService.getUser().cognitoSub,
        isOperator : window.location.pathname.includes('operator'),
        viewHoldingModalOpen : false,
        holdingsInBidWanted : [],
        showFilters : false,
        accountList : [],
        filterAccounts : [],
        isSelectAll : false,
        selectedHoldingsMap : {},
        bulkPayload : null,
        bulkResult : null
    };
  },
  computed: {
    selectedHoldings() {
      return Object.values(this.selectedHoldingsMap);
    },
    selectedCount() {
      return Object.keys(this.selectedHoldingsMap).length;
    },
    hasAccountFilter() {
      return this.filterAccounts && this.filterAccounts.length > 0;
    },
    canBulkAssign() {
      if (this.selectedCount > 0) {
        return this.selectedHoldings.some(holding => !holding.operatorCognitoSub);
      }
      return this.hasAccountFilter;
    },
    canBulkSend() {
      if (this.selectedCount > 0) {
        return this.selectedHoldings.some(holding => holding.operatorCognitoSub === this.cognitoSub);
      }
      return this.hasAccountFilter;
    }
  },
  methods: {
    searchHoldingDelayed(){
      setTimeout(() => {
        this.searchHolding();
      }, 100);
    },
    sendToEcn(holding){
      this.selectedHolding = holding.bidWantedInventoryListDto;
      this.selectedHolding.forEach(element => {
        element.cusipVal = holding.cusipVal;
        element.cusipDescription = holding.cusipDescription;
        element.id = holding.id;
        element.cusipId = holding.cusipId;
        element.traderCognitoSub = holding.traderCognitoSub;
      });
      
      this.toggleCreateBidWantedModalOpen();
    },
    toggleViewHoldingModalOpen(holdings){
      this.holdingsInBidWanted = holdings
      this.viewHoldingModalOpen = !this.viewHoldingModalOpen;
    },
    searchHolding(){
      this.currentPage = 1;
      this.clearSelection();
      this.getHoldingList(); 
    },
    clearSearch(){
      this.searchValue = "";
      this.currentPage = 1;
      this.getHoldingList(); 
    },
    clearFilter(){
      this.filterAccounts = [];
      this.currentPage = 1;
      this.clearSelection();
      this.getHoldingList();
    },
    getFilteredAccountIds(){
      return this.filterAccounts.map(account => account.accountMappingId);
    },
    getFilteredAccountQuery(){
      return this.filterAccounts.map(account => account.account).toString();
    },
    buildBulkScope(selectedIds){
      if (selectedIds && selectedIds.length > 0) {
        return {
          ids: selectedIds,
          accountIds: null
        };
      }
      if (this.hasAccountFilter) {
        return {
          ids: null,
          accountIds: this.getFilteredAccountIds()
        };
      }
      return null;
    },
    toggleCreateBidWantedModalOpen(){
      this.createBidWantedModalOpen = !this.createBidWantedModalOpen;
      if(!this.createBidWantedModalOpen){
        this.getHoldingList();  
      }
    },
    toggleBulkSendToEcnModalOpen(){
      this.bulkSendToEcnModalOpen = !this.bulkSendToEcnModalOpen;
      if(!this.bulkSendToEcnModalOpen){
        this.clearSelection();
        this.getHoldingList();
      }
    },
    selectHolding(holding){
      if(holding.isSelect){
        this.$set(this.selectedHoldingsMap, holding.id, holding);
      }else{
        this.$delete(this.selectedHoldingsMap, holding.id);
        this.isSelectAll = false;
      }
      this.syncSelectAllState();
    },
    selectAll(){
      this.holdingsList.forEach((holding) => {
        holding.isSelect = this.isSelectAll;
        if(this.isSelectAll){
          this.$set(this.selectedHoldingsMap, holding.id, holding);
        }else{
          this.$delete(this.selectedHoldingsMap, holding.id);
        }
      });
    },
    clearSelection(){
      this.isSelectAll = false;
      this.selectedHoldingsMap = {};
      this.holdingsList.forEach((holding) => {
        holding.isSelect = false;
      });
    },
    retainSelection(){
      this.holdingsList.forEach((holding) => {
        holding.isSelect = !!this.selectedHoldingsMap[holding.id];
        if(holding.isSelect){
          this.$set(this.selectedHoldingsMap, holding.id, holding);
        }
      });
      this.syncSelectAllState();
    },
    syncSelectAllState(){
      this.isSelectAll = this.holdingsList.length > 0 && this.holdingsList.every(holding => holding.isSelect);
    },
    getHoldingList(){
      this.loading = true;
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
        .get(
           config.baseUrlBidSide +
            "/bidwanted/listall?page=" +
            this.currentPage +
            "&size=" +
            this.perPage +
            "&search=" +
            this.searchValue +
            "&status=NEW,ASSIGNED_TO_OPERATOR"+
            "&sortColumn=" +
            this.sortColumn +
            "&sortOrder=" +
            this.sortOrder +
            "&accounts=" +
            this.getFilteredAccountQuery(),
            auth
        )
        .then(result => {
          this.totalRows = result.data.pageInfo.totalElements;
          result.data.content.forEach((data) => {
            const key = 'customerId';
            const accountKey = 'accountMapId'
            const customers = [...new Map(data.bidWantedInventoryListDto.map(item => [item[key], item])).values()];
            const accounts = [...new Map(data.bidWantedInventoryListDto.map(item => [item[accountKey], item])).values()];
            data.bidWantedInventoryListDtoCopy = customers;
            data.bidWantedInventoryListDtoAccount = accounts;
            data.isSelect = false;
          });
          this.holdingsList = result.data.content;
          this.retainSelection();
          this.loading = false;
        }).catch(() => this.loading = false);
    },
    getAccountList(){
      const auth = {
        headers: { 'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
           config.baseUrlBidSide +
            "/inventory/account-map-list",
            auth
        )
        .then((result) => {
          this.accountList = result.data;
        })
    },
    assignToMe(holding){
      var message = `Are you sure you want to assign this holding to you?`;
      this.$confirm(message,"","question",{confirmButtonText:"YES",cancelButtonText : "NO"}).then(() => {
        this.loading = true;
        const auth = {
            headers: { 'org-token' : authService.getOrgToken()  }
        };
        let data = {
            "id": holding.id,
            "cognitoSub" : authService.getUser().cognitoSub
        }
        this.$http
        .put(config.baseUrlBidSide + "/bidwanted/assign-to-me",data,auth)
        .then(() => {
            this.loading = false; 
            this.getHoldingList();             
            this.$alert("Holding has been successfully assigned to you.","","success")
        })
        .catch(() => {
            this.loading = false;              
        });
    })
      },
    assignSelectedToMe(){
      let selectedIds = null;
      if (this.selectedCount > 0) {
        const unassigned = this.selectedHoldings.filter(holding => !holding.operatorCognitoSub);
        if(!unassigned.length){
          this.$alert("Please select any unassigned bid wanted","","error");
          return;
        }
        selectedIds = unassigned.map(holding => holding.id);
      }
      const scope = this.buildBulkScope(selectedIds);
      if(!scope){
        this.$alert("Please select bid wanted(s) or filter by account","","error");
        return;
      }
      const message = scope.ids
        ? `Are you sure you want to assign ${scope.ids.length} bid wanted(s) to you?`
        : `Are you sure you want to assign all bid wanted(s) for the filtered account(s) to you?`;
      this.$confirm(message,"","question",{confirmButtonText:"YES",cancelButtonText : "NO"}).then(() => {
        this.loading = true;
        const auth = {
            headers: { 'org-token' : authService.getOrgToken()  }
        };
        let data = {
            "ids": scope.ids,
            "accountIds": scope.accountIds,
            "cognitoSub" : authService.getUser().cognitoSub
        }
        this.$http
        .put(config.baseUrlAutoBidder + "/bidwanted/assign-all-to-me",data,auth)
        .then(() => {
            this.loading = false;
            this.clearSelection();
            this.getHoldingList();
            this.$alert("Bid wanted(s) have been successfully assigned to you.","","success")
        })
        .catch(() => {
            this.loading = false;
        });
      })
    },
    sendSelectedToEcn(){
      let selectedIds = null;
      if (this.selectedCount > 0) {
        const assignedToMe = this.selectedHoldings.filter(holding => holding.operatorCognitoSub === this.cognitoSub);
        if(!assignedToMe.length){
          this.$alert("Please select any bid wanted assigned to you","","error");
          return;
        }
        selectedIds = assignedToMe.map(holding => holding.id);
      }
      const scope = this.buildBulkScope(selectedIds);
      if(!scope){
        this.$alert("Please select bid wanted(s) or filter by account","","error");
        return;
      }
      this.bulkPayload = {
        ids: scope.ids,
        accountIds: scope.accountIds,
        traderCognitoSub: null,
        operatorCognitoSub: authService.getUser().cognitoSub,
        userId: authService.getUser().id
      };
      this.bulkResult = null;
      this.bulkSendToEcnModalOpen = true;
    }
  },
  mounted() {
    this.getAccountList();
    this.getHoldingList();
  }
};
</script>

<style scoped>
/* Keep all toolbar actions on a single row when a selection is active */
.abs-btn-grp {
  max-width: min(72%, calc(100% - 60px));
  column-gap: 6px;
}

/* Compact selection indicator (replaces the bulky badge + full-width button) */
.selection-chip {
  display: inline-flex;
  align-items: center;
  height: 38px;
  padding: 0 4px 0 12px;
  background: #fff;
  border-radius: 5px;
  color: #303030;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
}
.selection-chip__count {
  line-height: 1;
}
.selection-chip__clear {
  border: 0;
  background: transparent;
  color: #9aa0a6;
  cursor: pointer;
  padding: 6px 8px;
  margin-left: 2px;
  line-height: 1;
  border-radius: 4px;
  transition: color 0.15s ease, background 0.15s ease;
}
.selection-chip__clear:hover {
  color: #e53935;
  background: #f2f2f2;
}
</style>

